var _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4745,
    height: 4746,
    viewBox: "0 0 4745 4746",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2372.95,
    cy: 2373,
    r: 2372.03,
    fill: "url(#paint0_radial_9091_589)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2372.95,
    cy: 2373,
    r: 1524,
    fill: "url(#paint1_radial_9091_589)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9091_589",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2372.95 2373) rotate(90) scale(2372.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795276,
    stopColor: "#737373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9091_589",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2372.95 2373) rotate(90) scale(1524)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#737373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795276,
    stopColor: "#737373",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.09e85e5a789016eb94393310a609acd6.svg";
export { ForwardRef as ReactComponent };